/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Select from 'Select';
import cn from 'classnames';
import Link from 'next/link';
import Router from 'next/router';
import Layout from '../../domain/Layout';
import useBuildInfo from '../../hooks/useBuildInfo';
import styles from '../../styles/pages/faqs.module.scss';

const FaqItem = ({ id, active, slug, title }) => {
   const classNameFaqItem = cn({
      [styles.faqItem]: true,
      [styles['faqItem--active']]: active,
   });

   return (
      <li key={id}>
         <Link href={`${slug}`}>
            <a className={classNameFaqItem}>{title}</a>
         </Link>
      </li>
   );
};

export default function FaqsWrapper(props) {
   const { buildInfo, faqs, activeFaq } = props;
   useBuildInfo(buildInfo);

   const renderFaqs = () => {
      return faqs.map((x) => {
         return (
            <FaqItem
               key={x.id}
               id={x.id}
               title={x.title}
               slug={x.slug}
               active={activeFaq.slug === x.slug}
            />
         );
      });
   };

   const handleSelect = (x) => {
      Router.push(x.id).then(() => window.scrollTo(0, 285));
   };

   return (
      <Layout
         title={activeFaq.title}
         description="Explora nuestras preguntas frecuentes para obtener respuestas rápidas. Encuentra información detallada sobre tiendas, productos envíos y más. "
      >
         <div className={styles.container}>
            <div className={styles.select}>
               <Select
                  placeholder="Seleccione un valor"
                  defaultValue={activeFaq.slug}
                  onChange={handleSelect}
                  options={faqs.map((x) => ({
                     id: x.slug,
                     value: x.title,
                  }))}
               />
            </div>

            <nav className={styles.sidebar}>
               <ul>{renderFaqs()}</ul>
            </nav>

            <div
               className={styles.content}
               dangerouslySetInnerHTML={{ __html: activeFaq.description }}
            />
         </div>
      </Layout>
   );
}
